import { FC, ReactNode, useEffect, useRef, useState } from "react";
import { I_midmileTrip, vehicleTypeDic } from "./types";
import { Provider, useProvider } from "./context";
import trucksrc from './images/truck.png';
import pickupsrc from './images/vanet.png';
import motosrc from './images/moto.png';
import sedansrc from './images/sedan.png';
import './index.css';
import { AIButtons, AISelect, IRPlate } from "./../../components/aio/aio-input";
import AIODate from './../../components/aio/aio-date';
import AIOTable from './../../components/aio/aio-table';
import usePopup from './../../components/aio/aio-popup';
import AIMap, { I_Map } from "./../../components/aio/aio-map";
import { useVehicles } from "./use-vehicles";
import Icon from "@mdi/react";
import { mdiBookOpenPageVariantOutline, mdiChevronLeft, mdiChevronLeftBox, mdiChevronRight, mdiCursorDefault, mdiCursorText, mdiPause, mdiPlay, mdiReload } from "@mdi/js";
import { mockData } from "./mock";
import { Apis } from "./apis";
import hubsrc from './../../components/monitoring/images/distribution.png';
export const MidmileMonitoring: FC<{ token: string }> = ({ token }) => {
    const base_url = process.env.REACT_APP_BASE_URL
    const apis = new Apis({ base_url, token })
    return <Midmile apis={apis} />
}
const Midmile: FC<{ apis: Apis }> = ({ apis }) => {
    const [hub, setHub] = useState<{ latitude: number, longitude: number, name: string }>({ latitude: 0, longitude: 0, name: 'هاب' })
    const [fontSize, setFontSize] = useState<number>(20)
    const changeFontSize = (v: number) => {
        setFontSize(v)
    }
    const popup = usePopup()
    const openDetaileModal = (row: I_midmileTrip) => {
        popup.addModal({
            header: { title: 'جزییات', subtitle: row.tripNumber },
            body: <MidmileDetail row={row} />
        })
    }
    const openReportModal = () => {
        popup.addModal({
            header: { title: 'گزارش' },
            body: <Report allVehicles={vehiclesHook.allVehicles} />
        })
    }
    const vehiclesHook = useVehicles(apis, (hub) => setHub(hub))
    return (
        <Provider value={{ vehiclesHook, vehicleTypeDic, hub, openDetaileModal, openReportModal, fontSize, changeFontSize }}>
            <div className="midmile midmile-bg2" style={{ fontSize }}>
                <Header />
                <Vehicles />
                {popup.render()}
            </div>
        </Provider>
    )
}
const Header: FC = () => {
    const DATE = new AIODate()
    const { hub, vehiclesHook, openReportModal, changeFontSize,fontSize } = useProvider()
    const { changePage, fetchData, toggleAuto, auto, changeTimer, changePageSize } = vehiclesHook
    const pair = (label: string, value: ReactNode) => {
        return (
            <div className="flex flex-row gap-1 items-center">
                <div className="">{label}</div>
                <div className="midmile-color5 font-bold">{value}</div>
            </div>
        )
    }
    return (
        <div className="midmile-header flex flex-row gap-4">
            <div className="flex flex-row gap-4">
                {pair('', hub.name)}
                {pair('سفر ها', vehiclesHook.allVehicles.length)}
            </div>
            <div className="flex-1"></div>
            <button className="button-1" onClick={openReportModal}>گزارش</button>
            <div className="flex flex-row items-center gap-4">
                <AISelect
                    text='تنظیمات'
                    className='midmile-button'
                    option={{
                        close:()=>false,
                        style:()=>({height:48})
                    }}
                    options={[
                        {
                            text: (
                                <Step
                                    initialValue={vehiclesHook.timer}
                                    step={5}
                                    min={5}
                                    max={60}
                                    getText={(v) => `بروز رسانی هر ${v} ثانیه`}
                                    icon={mdiBookOpenPageVariantOutline}
                                    onChange={(v) => changeTimer(v)}
                                />
                            )
                        },
                        {
                            text: (
                                <Step
                                    initialValue={fontSize}
                                    step={2}
                                    min={16}
                                    max={36}
                                    getText={(v) => `اندازه ${v}`}
                                    icon={mdiBookOpenPageVariantOutline}
                                    onChange={(v) => changeFontSize(v)}
                                />
                            )
                        },
                        {
                            text: (
                                <Step
                                    initialValue={vehiclesHook.pageSize}
                                    step={1}
                                    min={2}
                                    max={10}
                                    getText={(v) => `${v} کارت در هر صفحه`}
                                    icon={mdiBookOpenPageVariantOutline}
                                    onChange={(v) => changePageSize(v)}
                                />
                            )
                        }
                    ]}
                />
                <div className="cursor-pointer" onClick={toggleAuto}>
                    <Icon path={auto ? mdiPause : mdiPlay} size={1} />
                </div>
                <div className="cursor-pointer" onClick={fetchData}>
                    <Icon path={mdiReload} size={1} />
                </div>
                <div className="cursor-pointer" onClick={changePage}>
                    <Icon path={mdiChevronLeftBox} size={1} />
                </div>
            </div>
            <div className="midmile-color4 flex flex-row items-center" style={{ fontSize: '80%' }}>
                {DATE.getDateByPattern(DATE.getToday(true), '{weekDay} {day} {monthString} {year} {hour}:{minute}')}
            </div>
        </div>
    )
}
const Step: FC<{ initialValue: number, getText: (v: number) => string, step: number, max: number, min: number, onChange: (v: number) => void, icon: any }> = (props) => {
    const [value, setValue] = useState<number>(props.initialValue)
    const valueRef = useRef<number>(value)
    valueRef.current = value;
    const change = (dir: 1 | -1) => {
        let newValue = valueRef.current + (props.step * dir);
        if (newValue > props.max) { newValue = props.min }
        if (newValue < props.min) { newValue = props.max }
        setValue(newValue)
        props.onChange(newValue)
    }
    return (
        <div className="text-lg p-1 rounded-md cursor-pointer midmile-button flex flex-row gap-1 h-[48px]">
            <div className="w-[36px] h-[36px] flex flex-row items-center justify-center"><Icon path={props.icon} size={0.7} color={'#3c8bfd'} /></div>
            <div className="w-[36px] h-[36px] flex flex-row items-center justify-center" onClick={()=>change(-1)}><Icon path={mdiChevronRight} size={0.7} /></div>
            <div className="flex flex-row justify-center" style={{width:200}}>{props.getText(valueRef.current)}</div>
            <div className="w-[36px] h-[36px] flex flex-row items-center justify-center" onClick={()=>change(1)}><Icon path={mdiChevronLeft} size={0.7} /></div>
            
        </div>
    )
}
const Vehicles: FC = () => {
    const { vehiclesHook } = useProvider()
    const { vehicles } = vehiclesHook
    return (
        <div className="flex-1 p-4 gap-2 flex flex-col">
            {vehicles.map((row, i) => <VehicleCard row={row} index={i} key={row.id} />)}
        </div>
    )
}

const VehicleCard: FC<{ row: I_midmileTrip, index: number }> = ({ row, index }) => {
    const srcs = [motosrc, pickupsrc, trucksrc, sedansrc]
    const src = srcs[row.vehicleType?.id || 0]
    return (
        <div className={`midmile-card rounded-lg midmile-bg1 text-white flex flex-row items-center p-4 gap-4 relative`}>
            <div className="midmile-card-icon">
                <div className="midmile-card-icon-bg"></div>
                <img src={src} />
                <div className="vehicle-index">{(row.index || 0) + 1}</div>
            </div>
            <div className="flex flex-col flex-1">
                <VehicleCardHeader row={row} onClick={() => { }} />
                <div className="flex flex-row py-4 midmile-bg7 rounded-md backdrop-blur-xs">
                    <Pair label='شماره سفر' value={row.tripNumber} flex={true} />
                    <Pair label='هاب مبدا' value={row.sourceHub.name} flex={true} />
                    <Pair label='پلاک' value={<IRPlate value={row.plate} attrs={{ style: { fontSize: '85%' } }} />} flex={true} />
                    <Pair label={row.driverMobile} value={row.driverName} flex={true} />
                </div>
            </div>
        </div>
    )
}
const VehicleCardHeader: FC<{ row: I_midmileTrip, onClick: () => void }> = ({ row, onClick }) => {
    const { openDetaileModal } = useProvider()
    let dateStr: false | string = false;
    if (isNaN(+row.timeToArriveInNextStatus)) { dateStr = false }
    else {
        const DATE = new AIODate();
        const nowT = new Date().getTime();
        if (!row.timeToArriveInNextStatus) { dateStr = '--:--' }
        else {
            const milisecond = +row.timeToArriveInNextStatus - nowT;
            const { hour, minute } = DATE.milisecondsToUnits({ milisecond, unit: "minute" })
            dateStr = `${hour} : ${minute}`
        }
    }
    return (
        <div className="flex flex-row items-center" onClick={onClick}>
            <div className="flex flex-row gap-2 items-center h-12">
                <div className="midmile-color5 font-bold">{row.currentStatus.text}</div>
            </div>
            <div className="flex-1"></div>
            {
                dateStr !== false &&
                <div className="midmile-color4 font-bold" style={{ direction: 'ltr' }}>
                    <NextStage dateStr={dateStr} nextStatusName={row.nextStatus?.text || ''} />
                </div>
            }
            <button className="button-1" onClick={(e) => {
                e.stopPropagation()
                openDetaileModal(row);
            }}>جزییات</button>
        </div>
    )
}
const Pair: FC<{ label: string, value: ReactNode, flex: boolean }> = ({ label, value, flex }) => {
    return (
        <div className="flex flex-col items-center justify-center" style={{ flex: flex ? 1 : undefined }}>
            <div className="midmile-color6 midmile-card-label">{label}</div>
            <div className="h-6"></div>
            <div className="text-white font-bold midmile-card-value">{value}</div>
        </div>
    )
}

const MAP: FC<I_Map> = (p) => {
    const key = 'p17629b8b76ae143a78ecc70946e02ee65ba0d2b6c'
    const url = `https://api.parsimap.ir/tile/parsimap/{z}/{x}/{y}?key=${key}`
    return (
        <AIMap {...p} tileAttrs={{ url, attribution: '&copy; <a href="https://parsimap.ir">Parsimap</a>' }} />
    )
}
const NextStage: FC<{ dateStr: string, nextStatusName: string }> = ({ dateStr, nextStatusName }) => {
    return (
        <div className="flex flex-row items-center gap-2 rounded-lg">
            <div className="text-white font-bold px-2 py-1 midmile-card-next-stage-label">{`تا مرحله ${nextStatusName}`}</div>
            <div className="midmile-color4 font-bold text-white px-2 py-1" style={{ direction: 'ltr', background: 'rgba(0,0,0,.2)' }}>{dateStr}</div>
        </div>
    )
}
const NextStageCell: FC<{ dateStr: string | false, nextStatusName: string }> = ({ dateStr, nextStatusName }) => {
    return (
        <div className="flex flex-row items-center gap-2 rounded-lg">
            <div className="midmile-color4 font-bold text-white px-2 py-1" style={{ direction: 'ltr', background: 'rgba(0,0,0,.2)' }}>{dateStr}</div>
            <div className="text-white font-bold px-2 py-1 midmile-card-next-stage-label">{`تا مرحله ${nextStatusName}`}</div>
        </div>
    )
}
const MidmileDetail: FC<{ row: I_midmileTrip }> = ({ row }) => {
    const { hub } = useProvider()
    const pair = (label: string, value: ReactNode) => {
        return (
            <div className="flex flex-row midmile-bg3 p-2 flex-1">
                <div className="flex-1">{label}</div>
                <div className="msf">{value}</div>
            </div>
        )
    }
    return (
        <div className="p-4 midmile-bg1 h-full text-white text-lg flex flex-col gap-2">
            <div className="flex flex-row gap-2">
                {pair('تعداد کیسه', row.numberOfBags)}
                {pair('تعداد مرسوله', row.numberOfConsignments)}
            </div>
            <div className="flex-1">
                <MAP
                    attrs={{ style: { height: '100%', width: '100%' } }}
                    pos={row.pos}
                    zoom={8}
                    marker={false}
                    markers={[
                        {
                            pos: [hub.latitude, hub.longitude],
                            html: (
                                <div style={{ width: 80, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                    <div style={{ color: '#000', background: 'rgba(255,255,255,0.5)', padding: '0 6px' }}>هاب جاری</div>
                                    <img src={hubsrc} alt='' style={{ width: 48 }} />
                                </div>
                            )
                        },
                        {
                            pos: [row.sourceHub.latitude, row.sourceHub.longitude],
                            html: (
                                <div style={{ width: 80, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                    <div style={{ color: '#000', background: 'rgba(255,255,255,0.5)', padding: '0 6px' }}>هاب مبدا</div>
                                    <img src={hubsrc} alt='' style={{ width: 48 }} />
                                </div>
                            )
                        }
                    ]}
                    zoomOptions={{ "control": false, wheel: true }}
                />
            </div>
        </div>
    )
}

const Report: FC<{ allVehicles: I_midmileTrip[] }> = ({ allVehicles }) => {
    const [vehicles, setVehicles] = useState<I_midmileTrip[]>(allVehicles)
    const [mode, setMode] = useState<'all' | 'incoming' | 'outcoming'>(('all'))
    const dic: any = {
        all: 'همه',
        incoming: 'ورودی هاب',
        outcoming: 'خروجی هاب'
    }
    return (
        <div className="midmile-report midmile-bg7" style={{ fontSize: 16 }}>
            <div className="">
                <AIButtons
                    options={['all', 'incoming', 'outcoming']}
                    option={{
                        text: (o) => dic[o],
                        value: (o) => o
                    }}
                    value={mode}
                    onChange={(v) => {
                        setMode(v)
                        const res = allVehicles.filter((o) => {
                            if (v === "all") { return true }
                            else if (v === 'incoming') {
                                return [0, 1, 2, 3].indexOf(o.currentStatus.id) !== -1
                            }
                            else {
                                return [4, 5, 6, 7].indexOf(o.currentStatus.id) !== -1
                            }
                        })
                        setVehicles(res)
                    }}
                />
            </div>
            <div className="msf">
                <AIOTable<I_midmileTrip>
                    value={vehicles}
                    columns={[
                        { title: 'شماره سفر', id: 'tripNumber', value: ({ row }) => row.tripNumber },
                        { title: 'مبدا', id: 'sourceHub', value: ({ row }) => row.sourceHub.name },
                        { title: 'وضعیت', id: 'status', value: ({ row }) => row.currentStatus.text },
                        {
                            title: 'مرحله بعدی', id: 'nextStage',
                            template: ({ row }) => {
                                if (!row.nextStatus?.text) { return null }
                                let dateStr: false | string = false;
                                if (!row.timeToArriveInNextStatus) { dateStr = '--:--' }
                                else {
                                    const DATE = new AIODate();
                                    const nowT = new Date().getTime();
                                    const milisecond = row.timeToArriveInNextStatus - nowT;
                                    const { hour, minute } = DATE.milisecondsToUnits({ milisecond, unit: "minute" })
                                    dateStr = `${hour} : ${minute}`
                                }
                                return <NextStageCell dateStr={dateStr} nextStatusName={row.nextStatus.text} />
                            }
                        }
                    ]}
                />
            </div>
        </div>
    )
}